import React, { useEffect, useState } from "react";
import { FetchPurchaseRequestByIdApi } from "../../apis/purchaseRequest.api";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { CircularProgress } from "@mui/material";
import { InformationUI } from "../../components/InformationUI";
import moment from "moment";
import { callApiAction } from "../../store/actions/commonAction";
import { useDispatch } from "react-redux";
import { findObjectKeyByValue } from "../../utils/main";
import {
  CURRENCY,
  MATERIAL_REQUEST_STATUS,
  MATERIAL_TYPE,
} from "../../utils/constants";

const PurchaseRequestViewController = ({ params }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fetchList = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await FetchPurchaseRequestByIdApi({ _id: params._id }),
        (response) => {
          setData(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        },
      ),
    );
  };

  useEffect(() => {
    fetchList();
  }, [params._id]);
  return (
    <CustomDialog
      id={"purchase-view"}
      loading={loading}
      err={data?.err}
      title={"Material Request Details"}
    >
      {loading ? (
        <CenteredBox>
          {" "}
          <CircularProgress />{" "}
        </CenteredBox>
      ) : (
        <>
          <InformationUI
            Data={[
              {
                label: "Date :",
                value: moment(data?.date).format("DD/MM/YYYY"),
              },

              {
                label: "Direct Purchase :",
                value: data?.isDirectPurchase ? "YES" : "NO",
                isField: !data?.isDirectPurchase,
              },
              {
                label: "Material Code :",
                value:
                  data?.materialDetails?.rawMaterial_code ||
                  data?.materialDetails?.sfg_Code ||
                  data?.materialDetails?.skd_Code ||
                  data?.materialDetails?.fg_Code ||
                  "NA",
                isField: data?.materialDetails?.rawMaterial_code,
              },
              {
                label: "Material Name :",
                value: data?.materialDetails?.name || "Other",
                isField: data?.materialDetails?.name,
              },

              {
                label: "Other Material Name :",
                value: data?.otherMaterialName || "NA",
                isField: !data?.otherMaterialName,
              },

              {
                label: "Material Type :",
                value:
                  findObjectKeyByValue(data?.materialType, MATERIAL_TYPE) ||
                  "NA",
                isField: data?.materialDetails?.materialType,
              },

              {
                label: "Quantity :",
                value: data?.quantity || "NA",
                isField: !data?.quantity,
              },
              {
                label: "Vendor :",
                value: data?.vendorId?.name || "NA",
                isField: !data?.vendorId?.name,
              },
              {
                label: "Amount :",
                value: data?.amount
                  ? `${data?.amount} ${findObjectKeyByValue(data?.currency, CURRENCY)}`
                  : "NA",
                isField: !data?.amount,
              },
              {
                label: "Status :",
                value:
                  findObjectKeyByValue(data?.status, MATERIAL_REQUEST_STATUS) ||
                  "NA",
                isField: !data?.status,
              },
              {
                label: "Link :",
                value: data?.link || "NA",
                isField: !data?.link,
              },
              {
                label: "Reason :",
                value: data?.reason || "NA",
                isField: !data?.reason,
              },
              {
                label: "Category :",
                value: data?.categoryId?.name || "NA",
                isField: !data?.categoryId?.name,
              },

              {
                label: "Project :",
                value: data?.project ? `${data?.project}` : "NA",
                isField: !data?.project,
              },

              {
                label: "Created By :",
                value: data?.requestCreatedBy?.name || "NA",
                isField: !data?.requestCreatedBy?.name,
              },

              {
                label: "MPN :",
                value: data?.materialDetails?.mpn || "NA",
                isField: !data?.materialDetails?.mpn,
              },
              // { label: "Updated By :", value: data?.requestUpdatedBy?.name || "NA", isField: !data?.requestUpdatedBy?.name },
              {
                label: "Approver : ",
                value: data?.approver1?.name || "NA",
                isField: !data?.approver1?.name,
              },
              {
                label: "Approval Date :",
                value: moment(data?.approval1Date).format("DD/MM/YYYY") || "NA",
                isField: !data?.approval1Date,
              },

              {
                label: "Order Placed By :",
                value: data?.orderPlacedBy?.name || "NA",
                isField: !data?.orderPlacedBy?.name,
              },

              {
                label: "Order Placed Date :",
                value:
                  moment(data?.orderPlacedDate).format("DD/MM/YYYY") || "NA",
                isField: !data?.orderPlacedDate,
              },

              {
                label: "Order Received By :",
                value: data?.orderReceivedBy?.name || "NA",
                isField: !data?.orderReceivedBy?.name,
              },

              {
                label: "Order Received Date :",
                value:
                  moment(data?.orderReceivedDate).format("DD/MM/YYYY") || "NA",
                isField: !data?.orderReceivedDate,
              },

              {
                label: "Transportation Charge :",
                value:
                  data?.transportationCharge !== undefined &&
                  data?.transportationCharge !== null
                    ? `${data?.transportationCharge} ${findObjectKeyByValue(
                        data?.transportationCurrency,
                        CURRENCY,
                      )}`
                    : "NA",
                isField:
                  data?.transportationCharge === undefined ||
                  data?.transportationCharge === null,
              },

              {
                label: "Duty Charge :",
                value:
                  data?.dutyCharge !== undefined && data?.dutyCharge !== null
                    ? `${data?.dutyCharge} ${findObjectKeyByValue(
                        data?.dutyCurrency,
                        CURRENCY,
                      )}`
                    : "NA",
                isField:
                  data?.dutyCharge === undefined || data?.dutyCharge === null,
              },
              {
                label: "Allocator :",
                value: data?.allocator?.name || "NA",
                isField: !data?.allocator?.name,
              },

              {
                label: "Allocation Date :",
                value:
                  moment(data?.allocationDate).format("DD/MM/YYYY") || "NA",
                isField: !data?.allocationDate,
              },

              {
                label: "Rejected By :",
                value: data?.rejectedBy?.name || "NA",
                isField: !data?.rejectedBy?.name,
              },

              {
                label: "Rejection Date :",
                value: moment(data?.rejectionDate).format("DD/MM/YYYY") || "NA",
                isField: !data?.rejectionDate,
              },

              {
                label: "Material Location :",
                value: data?.materialDetails?.location || "NA",
                isField: !data?.materialDetails?.location,
              },
              {
                label: "Unit Price :",
                value: `₹ ${data?.materialDetails?.price_per_unit}` || "NA",
                isField: !data?.materialDetails?.price_per_unit,
              },
              {
                label: "Lead Time :",
                value: `${data?.materialDetails?.lead_time} days` || "NA",
                isField: !data?.materialDetails?.lead_time,
              },
            ]}
          />
        </>
      )}
    </CustomDialog>
  );
};

export default PurchaseRequestViewController;
